import {
    IconButton,
    Badge,
    Menu,
    MenuItem,
    Typography,
    Box,
    Divider,
    Paper,
} from "../ui";
import NotificationsIcon from "../ui/icons/Notifications";
import { useEffect, useState } from "react";
import "./NotificationBell.css";
import SnpButton from "../global/SnpButton";
import { SnpLocalStorage, ENABLE_NOTIFICATION_SOUND, NOTIFICATION_SOUND_NEXT_INTERVAL } from "../../utilities/snpLocalStorage";

export default function NotificationBell({
    count,
    getNotifications,
    onClickNotificationItem,
    onSeeAll
}) {
    const [pulse, setPulse] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [notifications, setNotifications] = useState([]);


    const open = Boolean(anchorEl);

    // --- Open Menu ---
    const handleClick = async (event) => {
        setAnchorEl(event.currentTarget);

        // fetch last 7 notifications
        const datas = await getNotifications();
        setNotifications(datas);
    };

    const handleClose = () => setAnchorEl(null);


    useEffect(() => {
        if (count === 0) return; // No animation if count is 0

        let interval;
        const notificationInterval = SnpLocalStorage.get(NOTIFICATION_SOUND_NEXT_INTERVAL, 8000);

        const startPulse = () => {
            // Only pulse when tab is focused
            if (document.visibilityState === "visible") {
                const isSound = SnpLocalStorage.get(ENABLE_NOTIFICATION_SOUND, true);

                setPulse(true);

                // play sound
                if (isSound) {
                    const audio = new Audio("/chat.wav"); // <-- place in /public/sounds
                    audio.volume = 0.8;
                    audio.play();
                }

                setTimeout(() => setPulse(false), 1000);
            }
        };

        // Trigger immediately every 10 seconds
        interval = setInterval(startPulse, Number(notificationInterval));

        return () => clearInterval(interval);
    }, [count]);

    return (
        <>
            <IconButton color="inherit" onClick={handleClick}>
                <Badge
                    badgeContent={count}
                    color={count > 0 ? "error" : "secondary"} // Red when > 0
                >
                    <div
                        className={
                            count > 0
                                ? `icon-wobble ${pulse ? "icon-pulse" : ""}` // Animate only when >0
                                : ""
                        }
                    >
                        <NotificationsIcon />
                    </div>
                </Badge>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        elevation: 5,
                        sx: {
                            width: 330,
                            borderRadius: 3,
                            paddingTop: 1,
                            paddingBottom: 1,
                        },
                    },
                }}
            >
                {notifications.length === 0 && (
                    <MenuItem>
                        <Typography variant="body2" color="text.secondary">
                            No new notifications
                        </Typography>
                    </MenuItem>
                )}

                {notifications.map((n, index) => (
                    <Box key={index}>
                        <MenuItem onClick={() => {
                            handleClose();
                            onClickNotificationItem(n.id, n.path);
                        }}
                            sx={{
                                whiteSpace: "normal",
                                alignItems: "flex-start",
                                cursor: "default",
                                "&:hover": { backgroundColor: "transparent" },
                            }}
                        >
                            <Box component={Paper} sx={{
                                borderRadius: "8px", border: 1,
                                borderColor: "lightgray", padding: "10px", cursor: "pointer"
                            }}>
                                <Typography
                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                    variant="subtitle1" fontWeight={600}>
                                    {n.title}
                                </Typography>
                                <Typography
                                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                    variant="p" color="#4a4e69">
                                    {n.message}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{ color: "gray", marginTop: 0.5, display: "block" }}
                                >
                                    {n.addedOn}
                                </Typography>
                            </Box>
                        </MenuItem>

                        {index < notifications.length - 1 && <Divider />}
                    </Box>
                ))}
                {/* ==== FOOTER BUTTON: SEE ALL ==== */}
                <Box px={2} pt={1}>
                    <SnpButton
                        fullWidth
                        variant="contained"
                        sx={{ borderRadius: 2 }}
                        onPointerDown={() => {
                            handleClose();
                            onSeeAll();
                        }}
                    >
                        See all notifications
                    </SnpButton>
                </Box>
            </Menu>
        </>
    );
}
